import { apiPost } from "../baseApi";

export const login = async (data) => {
  try {
    const response = await apiPost("_login", data);
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
